import { useLoaderData } from "react-router-dom";
import { Wrapper } from "./style";


export const PartnersPage = () => {
  const stuff = useLoaderData();
  return <Wrapper>Partners</Wrapper>;
};
